import "./../styles/news.css";
import React from 'react';

const CompanyProfile = () => {
    const employments = [
        {
            Title: "根据《省科技厅关于2025年度江苏省科学技术奖提名工作的通知》（苏科资发〔2026〕74号）文件要求进行公示",
            content: "江苏各地市  ",

        },
    ];
    return (
        <div className="join">
            <img src="/assets/news.png" alt="加入我们"/>
            <div className="title">
                <div className="titleBefore">新闻资讯</div>
                <div className="titleEnd">NEWS</div>
                <div className="temp"></div>
            </div>
            <div className="news">
                {employments.map((employment, index) => (
                    <div className='newsItem'>
                        <div className='newsItemTitle'>{employment.Title}</div>
                        <div className='newsItemDetail' onClick={() => window.open('/NewDetail', '_blank')}
                        >查看详情>>
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
};
export default CompanyProfile;
